import usePermissions from 'hooks/usePermissions'
import isNil from 'lodash/isNil'
import reject from 'lodash/reject'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { getFormattedDate } from 'utils/dates'

import Ui from '../../ui'
import { buildFullName, handleServerSearch } from '../../utils/helpers'
import { ZentakeContext } from '../../utils/ZentakeContext'

function SearchClientBar() {
  const history = useHistory()
  const { fetchingClients, clients, searchClients } = useContext(ZentakeContext)

  const [clientsWithId, setClientsWithId] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  const performHandleSearch = useCallback(async () => {
    await searchClients(
      handleServerSearch({
        searchTerm,
        paginated: false,
      })
    )
    // eslint-disable-next-line
  }, [searchTerm])

  useEffect(() => {
    if (!searchTerm || searchTerm.length < 3) return
    performHandleSearch()
    // eslint-disable-next-line
  }, [searchTerm])

  useEffect(() => {
    setClientsWithId(reject(clients, (c) => isNil(c?.id)))
  }, [clients])

  const formatLabel = useCallback(
    (c) =>
      c
        ? `${buildFullName(c.first_name, c.last_name)}, ${
            c.email ?? getFormattedDate(c.date_birth, 'MM-DD-YYYY', true) ?? ''
          }`
        : null,
    []
  )

  const onSelect = useCallback(
    (selection) => {
      if (!isNil(selection?.id)) {
        history.push(`clients/${selection.id}`)
      }
    },
    [history]
  )

  const { canViewClientProfile } = usePermissions()

  if (!canViewClientProfile) return null

  return (
    <Ui.Select
      hasError={false}
      labelFormatter={formatLabel}
      loading={fetchingClients}
      onChange={onSelect}
      onCreate={() => {}}
      onType={(value) => {
        setSearchTerm(value)
      }}
      options={clientsWithId || []}
      placeholder="Search client"
      target="dashboard_client_search"
      value={0}
      valueProp="id"
    />
  )
}

export default SearchClientBar
